import Telefonos from "./Telefonos";
export default Telefonos;